












import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company, FinanceInfo, CompanyManagerGradeReport } from '@/utils/Interfaces'
import BaoCaoGeneric from '@/components/BaoCaoGeneric.vue'

declare interface FormattedReport extends CompanyManagerGradeReport {
  company: Company['name'];
  finance_info: CompanyManagerGradeReport['finance_info'];
  ty_suat_loi_nhuan_ke_hoach: CompanyManagerGradeReport['ty_suat_loi_nhuan_ke_hoach'];
  ty_suat_loi_nhuan_thuc_hien: CompanyManagerGradeReport['ty_suat_loi_nhuan_thuc_hien'];
  ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: CompanyManagerGradeReport['ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach'];
  xep_loai_doanh_nghiep: CompanyManagerGradeReport['xep_loai_doanh_nghiep'];
  tinh_hinh_chap_hanh: CompanyManagerGradeReport['tinh_hinh_chap_hanh'];
  xep_loai_NQL_doanh_nghiep: CompanyManagerGradeReport['xep_loai_NQL_doanh_nghiep'];
}


@Component({
  components: {
    BaoCaoGeneric,
  }
})
export default class BaoCaoXepLoaiNQLDN extends Vue {
  @Prop(Array) readonly reports!: Array<CompanyManagerGradeReport>

  reportType = 'BaoCaoXepLoaiNQLDN'

  headerMapper: { [index: string]: string } = {
    company: 'Công ty',
    ty_suat_loi_nhuan_ke_hoach: 'Tỷ suất lợi nhuận KH',
    ty_suat_loi_nhuan_thuc_hien: 'Tỷ suất lợi nhuận TH',
    ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: 'Tỷ suất lợi nhuận TH / KH',
    xep_loai_doanh_nghiep: 'Xếp loại doanh nghiệp',
    tinh_hinh_chap_hanh: 'Tình hình chấp hành',
    xep_loai_NQL_doanh_nghiep: 'Xếp loại hoạt động người QLDN',
  }

  formatMapper: { [index: string]: string | null } = {
    company: 'link',
    ty_suat_loi_nhuan_ke_hoach: 'percentage',
    ty_suat_loi_nhuan_thuc_hien: 'percentage',
    ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: 'percentage',
    xep_loai_doanh_nghiep: 'select',
    tinh_hinh_chap_hanh: 'select',
    xep_loai_NQL_doanh_nghiep: 'select',
  }

  choicesMapper: { [index: string]: unknown } = {
    xep_loai_doanh_nghiep: ['A', 'B', 'C'],
    tinh_hinh_chap_hanh: ['Thực hiện tốt', 'Không thực hiện tốt'],
    xep_loai_NQL_doanh_nghiep: ['Hoàn thành tốt nhiệm vụ', 'Hoàn thành nhiệm vụ', 'Không hoàn thành nhiệm vụ'],
  }

  get formattedReports () {
    const formattedReports: Array<FormattedReport> = []

    this.reports.forEach(report => {
      // @ts-expect-error
      const formattedReport: FormattedReport = {}

      // Get company name
      const financeInfo = report.finance_info as FinanceInfo
      const company = financeInfo.company as Company
      const companyName = company.name
      formattedReport.company = companyName

      // Get remaining info
      Object.assign(formattedReport, report)
      // Remove not needed info
      delete formattedReport.finance_info
      delete formattedReport.created_at
      delete formattedReport.updated_at

      formattedReports.push(formattedReport)
    })

    return formattedReports
  }
}
